
import { defineComponent } from "vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";

export default defineComponent({
  name: "BaseNothingToShow",
  components: { BaseTypography },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
});
